import React, { useCallback, useEffect, useMemo, useState } from 'react';

import SelectCheckboxIntegracao from '@/features/enterprise/components/SelectCheckboxIntegracao';
import { useIntegrationContext } from '@/features/enterprise/contexts/IntegrationContext';
import { FhirArtefatoType } from '@/features/enterprise/models/types';

import { PassoExecutado } from '@/models/PassoExecutado';

import OptionIntegracao from '@/types/OptionIntegracao';
import useIntegration from '../../../hooks/useIntegration';

import { Content, Wrapper } from './styles';

interface ListaAgendamentosFhirProps {
  agendamentos: FhirArtefatoType[];
  passo: PassoExecutado;
}

const ListaAgendamentosFhir: React.FC<ListaAgendamentosFhirProps> = ({
  agendamentos,
  passo,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<OptionIntegracao[]>(
    [],
  );

  const {
    integrationItems,
    integrationStatus,
    integrationTotalSelected,
    changeIntegrationStatus,
    toOptionIntegracao,
  } = useIntegration({ items: agendamentos, passoExecutado: passo });

  const [
    { agendamentosStatus },
    ,
    { updateAgendamentosStatus },
  ] = useIntegrationContext();

  const options = useMemo(() => {
    return (integrationItems as FhirArtefatoType[]).map(
      (agendamento, index) => {
        const option = {
          key: `${index}`,
          title: agendamento.titulo,
          detail: agendamento.descricao,
          categoria: agendamento.categoria,
          value: agendamento.id,
          pedido: agendamento.pedido,
          solicitacao_obrigatoria: agendamento.solicitacao_obrigatoria,
          solicitacao_obrigatoria_motivo:
            agendamento.solicitacao_obrigatoria_motivo,
          selectedDefault: !!agendamento.solicitacao_pre_selecionada,
          sessionId: agendamento.session_id,
        } as OptionIntegracao;

        return toOptionIntegracao(option);
      },
    );
  }, [integrationItems, toOptionIntegracao]);

  const handleChange = useCallback((opts: OptionIntegracao[]) => {
    setSelectedOptions(opts);
  }, []);

  useEffect(() => {
    updateAgendamentosStatus(integrationStatus, selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [integrationStatus, selectedOptions]);

  useEffect(() => {
    if (selectedOptions && integrationStatus !== 'disabled') {
      changeIntegrationStatus(selectedOptions.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  return (
    <Wrapper>
      <Content>
        <SelectCheckboxIntegracao
          type="Agendamento"
          options={options}
          generalStatus={passo.executado ? 'disabled' : agendamentosStatus}
          totalSolicitados={integrationTotalSelected}
          onChange={handleChange}
        />
      </Content>
    </Wrapper>
  );
};

export default ListaAgendamentosFhir;
